"use client";

import { redirect, useSearchParams } from "next/navigation";
import { VFCComponentInterface } from "@/app/VFCInterface";
import { useClientSideAuth, useTNFromParams } from "@/hooks";
import { isValidTN } from "@/utils/general";

export default function createVoiceFeaturesRedirect() {
    return function VoiceFeaturesRedirect({ params }: VFCComponentInterface) {
        const resolvedParams = params;
        const { tn } = useTNFromParams(resolvedParams);
        useClientSideAuth();
        const searchParams = useSearchParams();
        if (tn !== null && tn !== "" && isValidTN(tn)) {
            redirect(`/voice-settings/${tn}/forwarding?${searchParams}`);
        }
    };
}
